"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var model_actions_creators_1 = require("./../../../store/model.actions.creators");
var Header_1 = require("./parts/Header");
var Responsibilities_1 = require("./parts/Responsibilities");
var CriminalBackground_1 = require("./parts/CriminalBackground");
var styles = __importStar(require("./PharmacyTechnician.module.css"));
function mapStateToProps(_a) {
    var model = _a.model;
    return { json_data: model.json_data };
}
var mapDispatchToProps = {
    updateJsonCallback: model_actions_creators_1.updateJson
};
var PharmacyTechnician = (function (_super) {
    __extends(PharmacyTechnician, _super);
    function PharmacyTechnician() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PharmacyTechnician.prototype.render = function () {
        var isPdf = false;
        var campus = this.props.json_data["campusState"] || "CA";
        if (window.isPdf) {
            isPdf = true;
        }
        return (react_1.default.createElement("div", { id: "asher_pharmacy_technician", className: styles.containerPosition + " " + styles.breakPage },
            !isPdf && react_1.default.createElement("div", { className: "gray-line " + styles.displayNone }),
            react_1.default.createElement("div", { className: styles.pageSize + " " + styles.paddingSides },
                react_1.default.createElement(Header_1.Header, { stateSelected: campus }),
                react_1.default.createElement(Responsibilities_1.AsherResponsibilities, { stateSelected: campus }),
                react_1.default.createElement(CriminalBackground_1.AsherCriminalBackground, { nextForm: this.props.nextForm, stateSelected: campus })),
            !isPdf && react_1.default.createElement("div", { className: "gray-line " + styles.displayNone })));
    };
    return PharmacyTechnician;
}(react_1.Component));
exports.AsherPharmacyTechnician = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(PharmacyTechnician);
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiUGhhcm1hY3lUZWNobmljaWFuLmNvbXBvbmVudC5qcyIsInNvdXJjZVJvb3QiOiIuLyIsInNvdXJjZXMiOlsicGRmL2Zvcm1zL2FzaGVyL1BoYXJtYWN5VGVjaG5pY2lhbi9QaGFybWFjeVRlY2huaWNpYW4uY29tcG9uZW50LnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBQUEsNkNBQXNDO0FBRXRDLDJDQUFtQztBQUNuQyxrRkFBa0U7QUFDbEUseUNBQXFDO0FBQ3JDLDZEQUE4RDtBQUM5RCxpRUFBa0U7QUFFbEUsc0VBQXlEO0FBRXpELFNBQVMsZUFBZSxDQUFDLEVBQU87UUFBTixnQkFBSztJQUMzQixPQUFPLEVBQUMsU0FBUyxFQUFFLEtBQUssQ0FBQyxTQUFTLEVBQUMsQ0FBQTtBQUN2QyxDQUFDO0FBRUQsSUFBTSxrQkFBa0IsR0FBRztJQUN2QixrQkFBa0IsRUFBRSxtQ0FBVTtDQUNqQyxDQUFBO0FBRUQ7SUFBaUMsc0NBQW1CO0lBQXBEOztJQXNDQSxDQUFDO0lBdkJHLG1DQUFNLEdBQU47UUFDSSxJQUFJLEtBQUssR0FBRyxLQUFLLENBQUE7UUFDakIsSUFBTSxNQUFNLEdBQUcsSUFBSSxDQUFDLEtBQUssQ0FBQyxTQUFTLENBQUMsYUFBYSxDQUFDLElBQUksSUFBSSxDQUFBO1FBQzFELElBQUksTUFBTSxDQUFDLEtBQUssRUFBRTtZQUNkLEtBQUssR0FBRyxJQUFJLENBQUE7U0FDZjtRQUVELE9BQU8sQ0FDSCx1Q0FBSyxFQUFFLEVBQUMsMkJBQTJCLEVBQUMsU0FBUyxFQUFLLE1BQU0sQ0FBQyxpQkFBaUIsU0FBSSxNQUFNLENBQUMsU0FBVztZQUMzRixDQUFDLEtBQUssSUFBSSx1Q0FBSyxTQUFTLEVBQUUsZUFBYSxNQUFNLENBQUMsV0FBYSxHQUFRO1lBQ3BFLHVDQUFLLFNBQVMsRUFBSyxNQUFNLENBQUMsUUFBUSxTQUFJLE1BQU0sQ0FBQyxZQUFjO2dCQUt2RCw4QkFBQyxlQUFNLElBQUMsYUFBYSxFQUFFLE1BQU0sR0FBSTtnQkFDakMsOEJBQUMsd0NBQXFCLElBQUMsYUFBYSxFQUFFLE1BQU0sR0FBSTtnQkFDaEQsOEJBQUMsNENBQXVCLElBQUMsUUFBUSxFQUFFLElBQUksQ0FBQyxLQUFLLENBQUMsUUFBUSxFQUFFLGFBQWEsRUFBRSxNQUFNLEdBQUcsQ0FDOUU7WUFDTCxDQUFDLEtBQUssSUFBSSx1Q0FBSyxTQUFTLEVBQUUsZUFBYSxNQUFNLENBQUMsV0FBYSxHQUFRLENBQ2xFLENBQ1QsQ0FBQTtJQUNMLENBQUM7SUFDTCx5QkFBQztBQUFELENBQUMsQUF0Q0QsQ0FBaUMsaUJBQVMsR0FzQ3pDO0FBRVksUUFBQSx1QkFBdUIsR0FBRyxxQkFBTyxDQUFDLGVBQWUsRUFBRSxrQkFBa0IsQ0FBQyxDQUFDLGtCQUFrQixDQUFDLENBQUEifQ==